module.exports = __webpack_public_path__ + "img/asus-zenfone-live-zb501kl.1e6d6181.jpg";